module.exports = __webpack_public_path__ + "static/media/tyre-three.9639df42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-three.png
// module id = 364
// module chunks = 0